import React from "react";
import "./ProcessDesign.scss";
import Slide1 from "../../assets/images/Slide-1.png";

const ProcessDesign = () => {
  return (
    <section className="section processDesign">
      <article className="processDesign__container container">
        <figure className="processDesign__container--img">
          <img src={Slide1} alt="process design" width={1000} height={1000} />
        </figure>

        <div className="processDesign__container--title">
          <h3 className="processDesign__title">
            Our Standard Design <br /> <span>Thinking Process</span>
          </h3>
        </div>

        <div className="processDesign__container--buttons">
          <button className="processDesign__btn-circle  strategy">
            Business Strategy
          </button>
          <button className="processDesign__btn research">Research</button>
          <button className="processDesign__btn define">Define</button>
          <button className="processDesign__btn design">Design</button>
          <button className="processDesign__btn evaluate">Evaluate</button>
          <button className="processDesign__btn-circle outcomes">
            Business Outcomes
          </button>
        </div>
      </article>
    </section>
  );
};

export default ProcessDesign;
